export const TOGGLE_USER_MENU = 'TOGGLE_USER_MENU'

export function displayUserMenuReducer (state = false, action) {
    switch (action.type){
        case TOGGLE_USER_MENU:
            return action.payload
        default: return state
    }
}